import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import SimpleField from '../simpleField'
import ToolTip from '../toolTip'
import './field.sass'

export default class Field extends React.Component {
  secondField = React.createRef()

  static propTypes = {
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    hidden: PropTypes.bool,
    touched: PropTypes.bool,
    error: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string.isRequired,
    label: PropTypes.string,
    mask: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    maxLength: PropTypes.number,
    white: PropTypes.bool,
    pair: PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
      error: PropTypes.string,
      divider: PropTypes.string,
      maxLength: PropTypes.number,
    }),
    autocomplete: PropTypes.bool,
    autofocus: PropTypes.bool,
    isErrorAbsolute: PropTypes.bool,
    placeholder: PropTypes.string,
    min: PropTypes.number,
    toolTip: PropTypes.string,
    // FIXME: rename to onChange/onBlur
    handleChange: PropTypes.func.isRequired,
    handleBlur: PropTypes.func,
  }

  static defaultProps = {
    className: '',
    touched: false,
    error: '',
    type: 'text',
    label: '',
    hidden: false,
    placeholder: '',
    maxLength: null,
    mask: null,
    min: null,
    white: false,
    autocomplete: true,
    autofocus: false,
    isErrorAbsolute: false,
    handleBlur: null,
    pair: null,
    toolTip: null,
  }

  state = {
    isFocused: false,
  }

  componentDidUpdate = prevProps => {
    if (
      this.props.pair &&
      prevProps.value.length !== this.props.value.length &&
      this.props.value.length === this.props.maxLength
    ) this.secondField.current.focus()
  }

  handleFocus = () => {
    this.setState({ isFocused: true })
  }

  handleBlur = e => {
    this.setState({ isFocused: false })
    if (this.props.handleBlur) this.props.handleBlur(e)
  }

  render() {
    const id = `field-${this.props.name}`

    const hasError = this.props.pair ? this.props.error || this.props.pair.error : this.props.error

    return (
      <div
        className={classNames('field', this.props.className, {
          'is-hidden': this.props.hidden,
          'is-invalid': this.props.touched && hasError,
          'is-empty':
            !this.state.isFocused &&
            !this.props.value &&
            !(this.props.pair && this.props.pair.value),
          '--white': this.props.white,
          '--with-absolute': this.props.isErrorAbsolute,
          'is-double': this.props.pair,
        })}
        key={this.props.name}
      >
        <label className="field__wrapper" htmlFor={id}>
          {(this.props.label || this.props.placeholder) && (
            <span className="field__label">{this.props.label || this.props.placeholder}</span>
          )}
          <SimpleField
            className="field__input"
            id={id}
            name={this.props.name}
            type={this.props.type}
            value={this.props.value}
            autocomplete={this.props.autocomplete}
            // placeholder={this.props.placeholder}
            isInvalid={Boolean(this.props.touched && this.props.error)}
            onFocus={this.handleFocus}
            onChange={this.props.handleChange}
            onBlur={this.handleBlur}
            maxLength={this.props.maxLength}
            mask={this.props.mask}
            min={this.props.min}
            autofocus={this.props.autofocus}
          />
          {this.props.pair && (
            <>
              {this.props.pair.divider}
              <SimpleField
                className="field__input"
                id={`${id}-2`}
                name={this.props.pair.name}
                type={this.props.type}
                value={this.props.pair.value}
                autocomplete={this.props.autocomplete}
                // placeholder={this.props.placeholder}
                isInvalid={Boolean(this.props.touched && this.props.pair.error)}
                onFocus={this.handleFocus}
                onChange={this.props.handleChange}
                onBlur={this.handleBlur}
                maxLength={this.props.pair.maxLength}
                mask={this.props.mask}
                min={this.props.min}
                autofocus={this.props.autofocus}
                inputRef={this.secondField}
              />
            </>
          )}
          {this.props.toolTip && <ToolTip image={this.props.toolTip} />}
        </label>
        {this.props.touched && this.props.error && (
          <div className={classNames('field__error', { '--absolute': this.props.isErrorAbsolute })}>
            {this.props.error}
          </div>
        )}
      </div>
    )
  }
}
